import { sendJSON } from "../../utils/request";

// Redux actions for CustomForm
export const setCustomForm = (customForm) => ({
  type: "CUSTOM_FORM_SET",
  payload: customForm,
});

export const updateFieldPosition = (pageNumber, fieldId, position) => ({
  type: "CUSTOM_FORM_UPDATE_FIELD_POSITION",
  payload: { pageNumber, fieldId, position },
});

export const removeField = (pageNumber, fieldId) => ({
  type: "CUSTOM_FORM_REMOVE_FIELD",
  payload: { pageNumber, fieldId },
});

export const updatePageDescription = (pageNumber, locale, description) => ({
  type: "CUSTOM_FORM_UPDATE_PAGE_DESCRIPTION",
  payload: { pageNumber, locale, description },
});

export const updateStaticPageDescription = (key, locale, description) => ({
  type: "CUSTOM_FORM_UPDATE_STATIC_PAGE_DESCRIPTION",
  payload: { key, locale, description },
});

export const addPage = () => ({
  type: "CUSTOM_FORM_ADD_PAGE",
});

export const removePage = (pageNumber) => ({
  type: "CUSTOM_FORM_REMOVE_PAGE",
  payload: pageNumber,
});

export const setMemberTypeProperties = (memberTypeProperties) => ({
  type: "CUSTOM_FORM_SET_MEMBER_TYPE_PROPERTIES",
  payload: memberTypeProperties,
});

export const setSaveStatus = (status) => ({
  type: "CUSTOM_FORM_SET_SAVE_STATUS",
  payload: status,
});

export const saveCustomForm = (url) => {
  return (dispatch, getState) => {
    const state = getState();
    const customForm = state.customForm.custom_form;
    const deletedPages = state.customForm.deleted_pages;
    const remainingRequired = getRemainingRequiredMemberTypeProperties(state);

    if (remainingRequired.length) {
      if (!confirm("You have left some required attributes out of the form. This form might not work as expected")) {
        return;
      }
    }

    dispatch(setSaveStatus("saving"));

    return sendJSON(url, {
      method: "PUT",
      body: {
        custom_form: {
          static_page_descriptions: customForm.static_page_descriptions,
          pages_attributes: customForm.pages.concat(deletedPages),
        },
      },
    })
      .then(() => {
        dispatch(setSaveStatus("success"));
      })
      .catch(() => {
        dispatch(setSaveStatus("error"));
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setSaveStatus(false));
        }, 2000);
      });
  };
};

// Helper selectors
const getCurrentFieldIds = (state) => {
  const pages = state.customForm.custom_form.pages;
  const fieldIds = pages.map((page) => page.fields).flat();
  return [...new Set(fieldIds)]; // unique values
};

const getVisibleMemberTypeProperties = (state) => {
  if(!state.customForm.custom_form.member_type_properties) {
    return [];
  }
  const currentFieldIds = getCurrentFieldIds(state);
  return state.customForm.member_type_properties.filter(
    (mtp) => !currentFieldIds.includes(mtp.id)
  );
};

const getRemainingRequiredMemberTypeProperties = (state) => {
  const visible = getVisibleMemberTypeProperties(state);
  return visible.filter((mtp) => mtp.required);
};
